module.exports = __webpack_public_path__ + "img/pills.f5402c02.svg";